import React from 'react';
import {
  ExpanderProps,
  TabbedAccordion,
  TabbedAccordionProps,
  IconType,
  LinkTarget,
} from '@atlassian/learning-components';
import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';

import {
  AssociatedContent,
  MlAccordion,
  MlNavtab,
  ReusableContentSection,
  ReusableContentSectionContentLinksItem,
} from 'src/graphql/generated/graphql';

import SectionHeading from './SectionHeading';

interface TabsSectionProps {
  tabs: MlNavtab;
}

const TabsSection: React.FC<TabsSectionProps> = ({ tabs }) => {
  const tabData: TabbedAccordionProps['tabs'] = tabs.contentCollection.items.map((item, index) => {
    const accordion = item as MlAccordion;
    const iconType = accordion.iconType as IconType;
    const tabsLabels = accordion.tabsLabel ?? [];

    const tabExpanders: ExpanderProps[] = accordion.tabsContentCollection.items.map((expanderItem, accordionIndex) => {
      const expander = expanderItem as ReusableContentSection;

      return {
        title: tabsLabels[accordionIndex] ?? expander.contentSectionTitle.contentSectionTitleExternal,
        description: expander.contentSectionTitle.contentSectionSubtitle,
        resources: expander.contentLinksCollection.items.map((link: ReusableContentSectionContentLinksItem) => {
          const associatedContent = link as AssociatedContent;

          return {
            description: associatedContent.description,
            link: {
              link: associatedContent.link?.link,
              target: associatedContent.link?.target as LinkTarget,
              label: associatedContent.link?.label,
              icon: (associatedContent.link?.icon as unknown as IconType) ?? 'arrow-right',
            },
            type: associatedContent.tag,
          };
        }),
      };
    });

    return {
      label: tabs.tabsLabel[index],
      color: tabs.tabColors[index],
      iconType,
      tabExpanders,
    };
  });

  return (
    <div css={containerStyles}>
      <SectionHeading
        heading={tabs.title}
        subtitle={tabs.description}
        containerStyles={{ textAlign: 'left', maxWidth: '940px', margin: 0 }}
      />
      <TabbedAccordion tabs={tabData} />
    </div>
  );
};

const containerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: token('space.500'),
});

export default TabsSection;
